/* eslint-disable no-unused-vars */
import { useContext, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Select from "react-select";

import axios from "axios";
import _ from "lodash";

import { ComplianceTest, LayoutContext, ToastContext } from "common/contexts";
import getGAUserID from "common/fetch/getGAUserID";
import sendData from "common/fetch/post";
import trigger from "common/trigger";

import ButtonNew from "components/atoms/ButtonNew/index";
import { BiLoaderAlt } from "components/atoms/Icon/bi/BiLoaderAlt";
import ReCaptcha from "components/atoms/Recaptcha/index";

import styles from "./Index.module.scss";

const customStyles = {
  container: (provided) => ({
    ...provided,
  }),
  control: (provided) => ({
    ...provided,
    borderRadius: 100,
    padding: "0px 16px",
    marginBottom: 8,
    lineHeight: "32px",
    borderColor: "#ddd !important",
    boxShadow: "none",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    padding: "4px 0px",
  }),
  menu: (provided, state) => ({
    ...provided,
    borderRadius: 20,
    overflow: "hidden",
  }),
  menuList: (provided, state) => ({
    ...provided,
    padding: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "8px 16px",
    color: state.isSelected ? "#002A66" : "#333",
    background: state.isSelected || state.isFocused ? "#F1FBFF" : "",
    fontWeight: state.isSelected ? "600" : "normal",
  }),
  input: (provided, state) => ({
    ...provided,
  }),
  indicatorsContainer: (provided) => ({
    border: "none",
  }),
};

export default function StartForm({ data, entity }) {
  const recaptchaRef = useRef();
  const [valuesEntity, setValueEntity] = useState();
  const { setFirstScreen, setUserData, setCountry, setEntityType, country } =
    useContext(ComplianceTest);
  const [loading, setLoading] = useState(false);
  const { openAlert } = useContext(ToastContext);
  const { locationRouter } = useContext(LayoutContext);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    clearErrors,
    getValues,
    formState: { isSubmitting, errors },
  } = useForm();
  const checkLocale = () => {
    if (locationRouter === "hk") {
      setCountry({
        label: "Hong Kong",
        value: 98,
      });
      setValue("company_country_id", 98, { shouldValidate: true });

      return {
        label: "Hong Kong",
        value: 98,
      };
    }
    if (locationRouter === "sg") {
      setCountry({
        label: "Singapore",
        value: 191,
      });
      setValue("company_country_id", 191, { shouldValidate: true });

      return {
        label: "Singapore",
        value: 191,
      };
    }
    if (locationRouter === "vn") {
      setCountry({
        label: "Vietnam",
        value: 244,
      });
      setValue("company_country_id", 244, { shouldValidate: true });

      return {
        label: "Vietnam",
        value: 244,
      };
    }
  };

  const countries = data.entityData.map((item) => ({
    label: item.sub_name,
    value: item.id,
  }));

  const onSubmit = async (data) => {
    setLoading(true);
    const token = await recaptchaRef.current.executeAsync();

    if (token) {
      const GAUserID = getGAUserID();
      const dataSend = { ...data };

      dataSend.contact_from_id = 33;
      dataSend.client_id = GAUserID ? GAUserID : "";
      dataSend.website_id = process.env.NEXT_PUBLIC_WEBSITE_ID;
      dataSend.country_name = country.label;
      // Axios
      //   .post(
      //     `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/contact_form/minitool_compliance`,
      //     Data,
      //     {
      //       Headers: {
      //         "captcha-response": token,
      //       },
      //     }
      // )
      sendData({
        api: `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/contact_form/minitool_compliance`,
        data: dataSend,
        token,
      })
        .then((response) => {
          reset();
          clearErrors();
          trigger(
            "contact_form",
            data,
            `Compliance Mini Test - ${data.country_name}`
          );
          if (response.state) {
            // OpenAlert(1000, "success");
            setFirstScreen(false);
            setUserData(data);
            setLoading(false);
          } else {
            openAlert(2000, "error");
            setLoading(true);
          }
        })
        .catch((error) => {
          setLoading(false);
          openAlert(2000, "error");
        });
    } else {
      setLoading(false);
      openAlert(2000, "error");
    }
  };
  const handleChange = (country) => {
    setValue("company_country_id", country.value, { shouldValidate: true });
    // eslint-disable-next-line no-undefined
    setValue("entity_type_id", undefined);
    setCountry(country);
    setEntityType(null);
    setValueEntity(null);
  };
  const handleChangeEntity = (entity) => {
    setValue("entity_type_id", entity.value, { shouldValidate: true });
    setEntityType(entity.value);
    setValueEntity(entity);
  };

  const sortList = (countries) => {
    return _.orderBy(countries, ["label", "value"], ["asc", "asc"]);
  };

  return (
    <div className={styles.startForm}>
      <h1
        className={`${styles.title} mb-4 text-center text-2xl font-bold uppercase 
        lg:mb-6 lg:text-left lg:text-5xl lg:leading-tight `}
      >
        {data.title}
      </h1>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Select
          {...register("company_country_id", {
            required: {
              value: true,
              message: "Country is required",
            },
          })}
          defaultValue={checkLocale}
          options={countries}
          className={" w-100"}
          isSearchable={true}
          inputMode="search"
          onChange={handleChange}
          placeholder={"Choose country you want to check"}
          styles={customStyles}
        />
        {errors.company_country_id?.message && (
          <span className="mb-4 inline-block px-2 text-sm text-red-500">
            {errors.company_country_id?.message}
          </span>
        )}

        {/* <input
          className="hidden"
          {...register("company_country_id", { required: true })}
          disabled={isSubmitting}
        /> */}

        <Select
          {...register("entity_type_id", {
            required: {
              value: true,
              message: "Entity Type is required",
            },
          })}
          options={sortList(entity)}
          className={" w-100"}
          isSearchable={true}
          onChange={handleChangeEntity}
          value={valuesEntity}
          placeholder={"Please select your entity type"}
          styles={customStyles}
        />
        {errors.entity_type_id?.message && (
          <span className="mb-4 inline-block px-2 text-sm text-red-500">
            {errors.entity_type_id?.message}
          </span>
        )}
        <div className="flex  overflow-hidden rounded-full border border-[#ddd]  bg-white px-1 py-1">
          <input
            type="email"
            {...register("email", {
              required: {
                value: true,
                message: "Email is required",
              },
              pattern: {
                value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
                message: "Invalid e-mail",
              },
            })}
            placeholder={"Your Email"}
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
            className="mr-1 w-full rounded-full border-0 p-0 pr-2 pl-4 leading-8 text-inherit focus:border-[#ddd] focus:ring-0"
          />

          <ButtonNew
            type="submit"
            othersClass="relative"
            style={{ minWidth: "170px" }}
            disabled={loading}
          >
            {isSubmitting && (
              <BiLoaderAlt
                className="absolute left-4 top-2.5 animate-spin"
                size={20}
              />
            )}
            Start Now
          </ButtonNew>
        </div>
        {errors.email?.message && (
          <span className="inline-block p-2 text-sm text-red-500">
            {errors.email?.message}
          </span>
        )}

        <div>
          <ReCaptcha
            ref={recaptchaRef}
            className={"mt-8 flex justify-center xl:justify-start"}
          />
        </div>
      </form>
    </div>
  );
}
